export default __webpack_public_path__ + "static/media/handshake.74374a42.svg";